interface Car {
	id: string;
	category: string;
	status: string;
	year: number;
	make: string;
	model: string;
	model_without_trim: string;
	trim: string;
	link: string;
	price: number;
	images: string[] | null;
	is_in_transit?: boolean;
}
export default Car;

export const VEHICLE_PLACEHOLDER_IMAGE = 'https://d1omuuphk28ngj.cloudfront.net/9c/9c158bb2a60f69095c228d4c61c0a77cfe6e0b21.png';
